/**
 * BNK KAM — Real User Monitoring (RUM)
 * AVG-compliant: geen PII, geen IP, geen user-ID
 * Meet: LCP, CLS, INP, TTFB, FCP per pagina per device-type
 */
(function () {
  'use strict';

  // B-338: hing eerst aan localStorage 'bnk_cookie_consent' van onze eigen cookiebalk. Die balk
  // is weg, dus die waarde wordt nooit meer gezet en dit script zou stilzwijgend nooit meer
  // draaien. Toestemming is hier ook niet nodig: er wordt niets verstuurd en niets opgeslagen,
  // de meting gaat alleen naar de console. Daarom nu een bewuste schakelaar: zet ?rum=1 achter
  // de URL wanneer je de prestatiecijfers wilt zien.
  if (!/[?&]rum=1(&|$)/.test(location.search)) return;

  if (!('PerformanceObserver' in window)) return;

  var metrics = {
    url:    location.pathname,
    device: window.innerWidth < 768 ? 'mobile' : 'desktop',
    lcp:    null,
    cls:    null,
    inp:    null,
    fcp:    null,
    ttfb:   null,
  };

  // TTFB via Navigation Timing API
  try {
    var navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry) {
      metrics.ttfb = Math.round(navEntry.responseStart - navEntry.startTime);
    }
  } catch (e) {}

  // LCP — Largest Contentful Paint
  try {
    var lcpObs = new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      var last = entries[entries.length - 1];
      metrics.lcp = Math.round(last.startTime);
    });
    lcpObs.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (e) {}

  // FCP — First Contentful Paint
  try {
    var fcpObs = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.name === 'first-contentful-paint') {
          metrics.fcp = Math.round(entry.startTime);
        }
      });
    });
    fcpObs.observe({ type: 'paint', buffered: true });
  } catch (e) {}

  // CLS — Cumulative Layout Shift
  try {
    var clsValue = 0;
    var clsObs = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!entry.hadRecentInput) clsValue += entry.value;
      });
      metrics.cls = Math.round(clsValue * 1000) / 1000;
    });
    clsObs.observe({ type: 'layout-shift', buffered: true });
  } catch (e) {}

  // INP — Interaction to Next Paint
  try {
    var inpObs = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!metrics.inp || entry.duration > metrics.inp) {
          metrics.inp = Math.round(entry.duration);
        }
      });
    });
    inpObs.observe({ type: 'event', buffered: true, durationThreshold: 16 });
  } catch (e) {}

  // Stuur metrics op page-verberging (meest betrouwbaar)
  function flush() {
    if (!metrics.lcp && !metrics.fcp) return;

    // Sla op in sessionStorage voor debugging
    try {
      var existing = JSON.parse(sessionStorage.getItem('bnk_rum') || '[]');
      existing.push(metrics);
      sessionStorage.setItem('bnk_rum', JSON.stringify(existing.slice(-10)));
    } catch (e) {}

    // Log naar console voor development/monitoring
    if (window.location.hostname.includes('myshopify.com') ||
        window.location.hostname.includes('localhost')) {
      console.debug('[BNK RUM]', metrics);
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush, { capture: true });
})();
